import { all } from "redux-saga/effects";
import { authSaga } from "./auth/authSaga";
import categorySaga from "./category/categorySaga";
import donHangSagaWrapper from "./don-hang/donHangSagaWrapper";
import quanLyKhoSagaWrapper from "./quan-ly-kho/quanLyKhoSagaWrapper";
import saleSetSagaWrapper from "./saleSet";
import sanPhamSagaWrapper from "./san-pham/sanPhamSagaWrapper";
import setTieuChuanSagaWrapper from "./set-tieu-chuan/setTieuChuanSagaWrapper";

export default function* rootSaga() {
  yield all([
    authSaga(),
    categorySaga(),
    sanPhamSagaWrapper(),
    donHangSagaWrapper(),
    setTieuChuanSagaWrapper(),
    quanLyKhoSagaWrapper(),
    saleSetSagaWrapper()
  ]);
}
